import { offerSvg, originalSvg, qualitySvg, returnSvg } from "./svg";

const footerItems = [
  { title: "Best Price Assured", icon: offerSvg },
  { title: "Quality Assured", icon: qualitySvg },
  { title: "100% Original", icon: originalSvg },
  { title: "Easy Return", icon: returnSvg },
];

const FooterBenefit = () => {
  return (
    <div className="pt-14">
      <div className="grid grid-cols-2 gap-8 md:flex md:items-center">
        {footerItems.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center bg-[#F0F0F0] rounded-lg w-[150px] h-[149px] lg:w-[215px] 2xl:w-[260px] md:h-[149px]"
          >
            {item.icon}
            <p className="mt-2 text-sm font-medium text-gray-700 text-center">{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterBenefit;
